<template>
  <a-table
    class="table"
    bordered
    :columns="tableData.columns"
    :data-source="tableData.data"
    :pagination="tableData.pagination"
  >
    <template slot="actions" slot-scope="text, record">
      <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
    </template>
  </a-table>
</template>
<script>
export default {
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '设备名称',
            dataIndex: 'name',
            align: 'left',
            width: '35%'
          },
          {
            title: '设备编号',
            dataIndex: 'number',
            align: 'left',
            width: '24%'
          },
          {
            title: '设备位置层级',
            dataIndex: 'hierarchy',
            align: 'left',
            width: '35%'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'center',
            width: '6%'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40', '9999'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: []
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      console.log(this.analogData)
      for (let i = 0; i < 99; i++) {
        this.analogData.push({
          key: 1 + `a${i}`,
          name: '六万空分设备',
          number: 'ASAWEWDASD-001',
          hierarchy: '/',
          children: [
            {
              key: 11 + `b${i}`,
              name: '压缩机组',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 111 + `c${i}`,
                  name: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 112 + `a${i}`,
                  name: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 113 + `a${i}`,
                  name: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 12 + `a${i}`,
              name: '空气预冷系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 121 + `a${i}`,
                  name: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 122 + `a${i}`,
                  name: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 123 + `a${i}`,
                  name: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 13 + `a${i}`,
              name: '分子筛纯化系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 131 + `a${i}`,
                  name: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 132 + `a${i}`,
                  name: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 133 + `a${i}`,
                  name: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 14 + `a${i}`,
              name: '透平膨胀机系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 141 + `a${i}`,
                  name: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 142 + `a${i}`,
                  name: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 143 + `a${i}`,
                  name: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            },
            {
              key: 15 + `a${i}`,
              name: '分馏塔系统',
              number: 'ASAWEWDASD-001',
              hierarchy: '六万空分设备/',
              children: [
                {
                  key: 151 + `a${i}`,
                  name: '原料空气压缩机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 152 + `a${i}`,
                  name: '空气增压机',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                },
                {
                  key: 153 + `a${i}`,
                  name: '汽轮杋组',
                  number: 'ASAWEWDASD-001',
                  hierarchy: '六万空分设备/压缩机组/'
                }
              ]
            }
          ]
        })
      }
      this.tableData.data = this.analogData
    },
    handleDetail () {}
  }
}
</script>

<style lang="less" scoped>
.table{
  margin-left: -1px;
  margin-right: -1px;
  // /deep/.ant-table-pagination.ant-pagination {
  //   margin-bottom: 10px !important;
  //   margin-right: 10px !important;
  // }

  /deep/.ant-table-thead > tr > th {
    background: rgba(8, 64, 159, 0.1);
  }
  /deep/.ant-table-tbody > tr > td {
    padding: 10px;
  }
}
</style>
